/**
 * Query configuration defaults for TanStack Query
 */

// Polling intervals (in milliseconds)
export const POLLING_INTERVALS = {
    SITE_DEPLOYING: 30 * 1000,
    DEFAULT: 60 * 1000,
};

// Stale times (in milliseconds)
export const STALE_TIMES = {
    // Site data changes frequently
    SITE: 30 * 1000,
    // Site groups don't change often
    SITE_GROUPS: 10 * 60 * 1000,
    // List data rarely changes
    STATIC_LISTS: 15 * 60 * 1000,
    DOMAIN: 10 * 60 * 1000,
    DEFAULT: 5 * 60 * 1000,
};
